import NotFoundPage from "@src/modules/member/components/not-found";
import {
  useCurrentOrganization,
  useOrganizationHasFeature,
} from "@src/modules/member/hooks/organizations";
import { FeatureSlug } from "@src/modules/member/models/organization";
import { ReactNode } from "react";

interface FeatureRouteProps {
  feature: FeatureSlug;
  children: ReactNode;
}

export default function FeatureRoute({ feature, children }: FeatureRouteProps) {
  const organization = useCurrentOrganization();
  const hasFeature = useOrganizationHasFeature(feature);

  if (!organization) {
    return null;
  }

  if (!hasFeature) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
}
